<!-- tripmeld-welcome.component.html -->
<div class="welcome-container">
  <div class="left-panel">
    <h2 class="headline">CRM platform to Grow your business</h2>
    <p class="subtext">
      Streamline operations, enhance customer experiences, and drive growth with our all-in-one travel industry
      solutions.
    </p>
    <div class="screenshots">
      <img src="assets/Images/landing-section-img.png" alt="Dashboard" class="main-dashboard" />
      <img src="assets/Images/crm-dashboard.webp" alt="Mobile UI" class="mobile-ui" />
    </div>
  </div>

  <div class="middle-panel">
    <!-- Show on successful verification -->
    <div class="message-box" *ngIf="checkStatus">
      <ion-icon name="mail-open-outline" style="font-size: 50px;"></ion-icon>
      <h1>Congratulations!</h1>
      <p>
        Your email address has been successfully verified, and you can now start sending emails using this address.
        Please log in <a class="link-orange" (click)="gotoLogin()">here</a> using your email address, even if you
        already have an active session.
      </p>
    </div>

    <!-- Show on verification failure -->
    <div class="message-box text-danger" *ngIf="!checkStatus">
      <img src="assets/mail-icon.svg" alt="Mail Icon" class="mail-icon" />
      <h1>Verification Failed</h1>
      <p>There was an issue while verifying your account. Please contact TripMeld support for assistance.</p>
    </div>
  </div>

  <!-- Assistance Section -->
  <div class="assistance d-flex flex-column justify-content-center px-4">
    <h5 class="fw-bold text-primary mb-1">Need Assistance</h5>
    <p class="mb-3 text-muted">Contact us for more details</p>

    <p class="mb-3">
      <ion-icon name="call-outline" class="me-2"></ion-icon>
      +91 928 111 7175
    </p>

    <p>
      <ion-icon name="mail-outline" class="me-2"></ion-icon>
      contact&#64;tripmeld.com
    </p>
    <p>
      <ion-icon name="mail-outline" class="me-2"></ion-icon>
      support&#64;tripmeld.com
    </p>
  </div>
</div>

<!-- Spinner (optional if needed) -->
<app-spinner *ngIf="showSpinner"></app-spinner>